import React from 'react';

export default function ScheduleSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.72412 5.44434C2.72412 5.03012 3.05991 4.69434 3.47412 4.69434H14.3173C14.7315 4.69434 15.0673 5.03012 15.0673 5.44434V17.8745C15.0673 18.1507 14.8434 18.3745 14.5673 18.3745H3.22412C2.94798 18.3745 2.72412 18.1507 2.72412 17.8745V5.44434Z"
        stroke="currentColor"
      />
      <path
        d="M0.864746 3.64941C0.864746 3.2352 1.20053 2.89941 1.61475 2.89941H14.3979C14.8121 2.89941 15.1479 3.2352 15.1479 3.64941V16.0796C15.1479 16.3558 14.924 16.5796 14.6479 16.5796H1.36475C1.0886 16.5796 0.864746 16.3558 0.864746 16.0796V3.64941Z"
        fill="white"
        stroke="currentColor"
      />
      <path d="M0.864746 5.35449H15.0674" stroke="currentColor" />
      <path
        d="M4.2424 3.6252H4.7424V3.1252V2.13194C4.7424 1.55802 4.27715 1.09277 3.70323 1.09277C3.12931 1.09277 2.66406 1.55802 2.66406 2.13194V3.1252V3.6252H3.16406H4.2424Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M8.53781 3.6252H9.03781V3.1252V2.13194C9.03781 1.55802 8.57256 1.09277 7.99864 1.09277C7.42472 1.09277 6.95947 1.55802 6.95947 2.13194V3.1252V3.6252H7.45947H8.53781Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M12.8332 3.6252H13.3332V3.1252V2.13194C13.3332 1.55802 12.868 1.09277 12.2941 1.09277C11.7201 1.09277 11.2549 1.55802 11.2549 2.13194V3.1252V3.6252H11.7549H12.8332Z"
        fill="white"
        stroke="currentColor"
      />
      <circle cx="2.91748" cy="7.68457" r="0.5" fill="currentColor" />
      <circle cx="4.91748" cy="7.68457" r="0.5" fill="currentColor" />
      <circle cx="2.91748" cy="9.68066" r="0.5" fill="currentColor" />
      <circle cx="4.91748" cy="9.68066" r="0.5" fill="currentColor" />
      <circle cx="6.896" cy="9.68066" r="0.5" fill="currentColor" />
      <circle cx="8.896" cy="9.68066" r="0.5" fill="currentColor" />
      <circle cx="2.91748" cy="11.6807" r="0.5" fill="currentColor" />
      <circle cx="2.91748" cy="13.6768" r="0.5" fill="currentColor" />
      <circle cx="4.91748" cy="11.6807" r="0.5" fill="currentColor" />
      <circle cx="6.896" cy="11.6807" r="0.5" fill="currentColor" />
      <circle cx="6.91748" cy="7.68457" r="0.5" fill="currentColor" />
      <circle cx="8.89575" cy="7.68457" r="0.5" fill="currentColor" />
      <circle
        cx="13.1955"
        cy="13.9948"
        r="4.77507"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M15.3192 12.106L13.136 14.2891L11.9805 13.1335"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
